import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { subtopics } from '../utils/messages'
import {
  fetchTopicClouds,
  fetchTopicCloud,
  clearCurrentTopicCloud
} from '../actions/topicclouds'
import TopicCloudList from '../components/topiccloud/topicmenu/List'
import SubTopicList from '../components/topiccloud/subtopics/List'
import { isExternalReviewer } from '../utils/user'

class TopicCloudsContainer extends Component {
  constructor(props) {
    super(props)
    this.onTopicCloudChangeBound = this.onTopicCloudChange.bind(this)
  }

  componentWillMount() {
    if (this.props.topicClouds.length === 0) {
      this.props.dispatch(fetchTopicClouds())
    } else {
      this.props.dispatch(
        fetchTopicCloud(
          this.props.currentTopicCloud
            ? this.props.currentTopicCloud.id
            : this.props.topicClouds[0].id
        )
      )
    }
  }

  componentWillUnmount() {
    this.props.dispatch(clearCurrentTopicCloud())
  }

  render() {
    const {
      currentTopicCloud,
      currentTopic,
      topicClouds,
      isFetchingTopicClouds,
      isFetchingTopic,
      dispatch,
      user
    } = this.props

    const topicCloudsOptionTags = topicClouds.map(function (tc, index) {
      return (
        <option value={tc.id} key={index}>
          {tc.name}
        </option>
      )
    })

    return (
      <div className="topic-clouds">
        {isFetchingTopicClouds && <div className="loading" />}
        {topicClouds && topicClouds.length > 0 && (
          <div className="topic-clouds-container">
            <div className="left">
              <div>
                <h3 className="select-topic-cloud">
                  <FormattedMessage
                    id={'Topics.SelectATopicCloud'}
                    defaultMessage={'Select A Topic Cloud'}
                  />
                </h3>
              </div>
              <div>
                <div id="topicCloudDropdown">
                  <select
                    className="aDropdown"
                    id="topicClouds"
                    defaultValue={
                      currentTopicCloud ? currentTopicCloud.id : undefined
                    }
                    onChange={this.onTopicCloudChangeBound}
                  >
                    {topicCloudsOptionTags}
                  </select>
                </div>
              </div>
              <div id="topicCloudTopics">
                <TopicCloudList
                  topics={currentTopicCloud ? currentTopicCloud.topics : []}
                  currentTopic={currentTopic}
                  dispatch={dispatch}
                  user={user}
                />
              </div>
            </div>
            <div className="right">
              <div className="topic-container">
                <div id="topicDetail">
                  {isFetchingTopic && <div className="loading" />}
                  {!isFetchingTopic && currentTopic && currentTopicCloud && (
                    <div>
                      <h2>{currentTopicCloud.name}</h2>
                      <div className="topic-header">
                        <h2>{currentTopic.name}</h2>
                        <div className="description">
                          {currentTopic.description}
                        </div>
                        {!isExternalReviewer(user) && (
                          <div className="stats">
                            <div className="count">
                              <span>
                                {currentTopic.stats.descendants_quests_count
                                  ? currentTopic.stats.descendants_quests_count
                                  : '0'}{' '}
                                QUESTS
                              </span>
                            </div>
                            <div className="count">
                              <span>
                                {currentTopic.subtopics.length} {subtopics}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                      <SubTopicList
                        dispatch={dispatch}
                        subtopics={currentTopic.subtopics}
                        user={user}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
        {!isFetchingTopicClouds && topicClouds && topicClouds.length === 0 && (
          <div className="topic-clouds-container empty">
            <h3>
              <FormattedMessage
                id={'Topics.NoTopicsExistYet'}
                defaultMessage={'No topics exist yet!'}
              />
            </h3>
            <div>
              <FormattedMessage
                id={'Topics.WhenOrgCreatesTopics'}
                defaultMessage={
                  "When your organization creates topics that coordinate with quests, they'll appear here."
                }
              />
            </div>
          </div>
        )}
      </div>
    )
  }

  onTopicCloudChange(e) {
    const selectedTopicCloudId =
      e.currentTarget.options[e.currentTarget.selectedIndex].value
    this.props.dispatch(fetchTopicCloud(selectedTopicCloudId))
  }
}

TopicCloudsContainer.propTypes = {
  currentTopic: PropTypes.object,
  currentTopicCloud: PropTypes.object,
  topicClouds: PropTypes.array,
  isFetchingTopicClouds: PropTypes.bool,
  isFetchingTopic: PropTypes.bool,
  dispatch: PropTypes.func,
  user: PropTypes.object
}

export const mapStateToProps = state => ({
  currentTopic: state.topicclouds.currentTopic,
  currentTopicCloud: state.topicclouds.currentTopicCloud,
  topicClouds: state.topicclouds.items,
  isFetchingTopicClouds: state.topicclouds.isFetchingTopicClouds,
  isFetchingTopic: state.topicclouds.isFetchingTopic,
  user: state.user.user
})

export default connect(mapStateToProps)(TopicCloudsContainer)
export { TopicCloudsContainer as TopicCloudsDisconnected }



// WEBPACK FOOTER //
// ./src/containers/TopicClouds.js